<div class="header">
  <span  style="font-size: 16px; font-weight: 500;">  Filters</span>
  <span (click)="closeBottomSheet()" style="float: right; color: #3880ff;">Close</span>
</div>


<mat-divider></mat-divider>
<mat-drawer-container class="example-container" [ngClass]="{'cb-vertival': !tmp }">

  <mat-drawer #drawer class="example-sidenav" mode="side" opened>
    <h3 tabindex="1" (click)="showDiv('Category')" > Category</h3>
    <h3 tabindex="2" (click)="showDiv('Brand')" *ngIf="brandList.length !== 0"> Brand</h3>
    <h3 tabindex="3" (click)="showDiv('Product')">Product name</h3>
    <h3 tabindex="4" (click)="showDiv('Version')"> Version</h3>
    <h3 tabindex="5" (click)="showDiv('Business')">Business Object</h3>
    <h3 tabindex="16" (click)="showDiv('Method')"> Method</h3>
    <h3 tabindex="7" (click)="showDiv('Type')"> Type</h3>
    <h3 tabindex="8" (click)="showDiv('Price')">Price</h3>
  </mat-drawer>

  <div class="example-sidenav-content">

    <!-- CATEGORY FILTER (Mob) -->
    <div *ngIf="currDiv == 'Category'">
      <div class="filteritems"  *ngIf="categoryList.length !== 0">
        <div *ngFor="let catalog of categoryList ">
          <mat-checkbox matInput #categoryCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="checkUncheckAll(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            {{catalog.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- BRAND FILTER (Mob) -->

    <div *ngIf="currDiv == 'Brand'">
      <div class="filteritems" *ngIf="brandList.length !== 0">
        <div *ngFor="let catalog of brandList ">
          <mat-checkbox matInput #brandCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="brand(catalog.id,catalog.brand,catalog,$event)"   >
            {{catalog.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- PRODUCT NAME FILTER (Mob) -->
    <div *ngIf="currDiv == 'Product'">
      <div class="filteritems" *ngIf="productnameList.length !== 0">
        <div *ngFor="let catalog of productnameList">
          <mat-checkbox matInput #productCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="productnames(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span>{{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- VERSION FILTER (Mob) -->
    <div *ngIf="currDiv == 'Version'">
      <div class="filteritems" *ngIf="versionList.length !== 0">
        <div *ngFor="let catalog of versionList">
          <mat-checkbox matInput #versionCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="version(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span> {{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- BUSINESS OBJECT FILTER (Mob) -->
    <div *ngIf="currDiv == 'Business'">
      <div class="filteritems" *ngIf="businesskobjList.length !== 0">
        <div *ngFor="let catalog of businesskobjList">
          <mat-checkbox matInput #businesskobjCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="businessobj(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span>{{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- METHOD FILTER (Mob) -->
    <div *ngIf="currDiv == 'Method'">
      <div class="filteritems" *ngIf="methodList.length !== 0">
        <div *ngFor="let catalog of methodList">
          <mat-checkbox matInput #methodCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="method(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span> {{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- TYPE FILTER (Mob) -->
    <div *ngIf="currDiv == 'Type'">
      <div class="filteritems" *ngIf="typeList.length !== 0">
        <div *ngFor="let catalog of typeList ">
          <mat-checkbox matInput #typeCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="type(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span>{{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- PRICE FILTER (Mob) -->
    <div *ngIf="currDiv == 'Price'">
      <div class="filteritems" *ngIf="priceDealsList.length !== 0">
        <div *ngFor="let catalog of priceDealsList ">
          <mat-checkbox matInput #priceCheckbox [(ngModel)]="catalog.IsChecked"
            (change)="price(catalog.id,catalog.name,catalog,$event)" [id]="catalog.name" [name]="catalog.id">
            <span> {{catalog.name}}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  

</mat-drawer-container>
<div class="header">
  <span *ngIf="filterarr.length !== 0"><button  (click)="clearFilters()" mat-button class="clear-btn" >Clear Filters</button></span>
  <button style="float: right;" (click)="showFilters()" mat-raised-button color="primary" class="show-btn">Apply</button>
</div>